// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"InfoButton_infoButton__36apJ","iconInfo":"InfoButton_iconInfo__us5IE"};